import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=d04d7954&scoped=true"
import script from "./Picture.vue?vue&type=script&setup=true&lang=js"
export * from "./Picture.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Picture.vue?vue&type=style&index=0&id=d04d7954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04d7954",
  null
  
)

export default component.exports